import { Checkbox } from "@trussworks/react-uswds";
import { SearchFilters } from "../../../types/v1_schemas";

type FilterDaysCheckboxProps = {
  name: string;
  value: string;
  label: string;
  filters: SearchFilters;
  onChange: () => void;
};

function FilterDaysCheckbox({
  name,
  value,
  label,
  filters,
  onChange,
}: FilterDaysCheckboxProps) {
  
  function getCheckedValue(filters: SearchFilters, value: string): boolean | undefined {
    switch(value) {
      case "Monday": {
        if (filters.openMonday && filters.openMonday.length) {
          return true;
        } else {
          return false
        }
      }      

      case "Tuesday": {
        if (filters.openTuesday && filters.openTuesday.length) {
          return true;
        } else {
          return false
        }
      }
      
      case "Wednesday": {
        if (filters.openWednesday && filters.openWednesday.length) {
          return true;
        } else {
          return false
        }
      }      

      case "Thursday": {
        if (filters.openThursday && filters.openThursday.length) {
          return true;
        } else {
          return false
        }
      }
      
      case "Friday": {
        if (filters.openFriday && filters.openFriday.length) {
          return true;
        } else {
          return false
        }
      }      

      case "Saturday": {
        if (filters.openSaturday && filters.openSaturday.length) {
          return true;
        } else {
          return false
        }
      }

      case "Sunday": {
        if (filters.openSunday && filters.openSunday.length) {
          return true;
        } else {
          return false
        }
      }
      default: 
        return false;
    }

  }

  return (
    <Checkbox
      id={value}
      name={name}
      label={label}
      checked={getCheckedValue(filters, value)}
      onChange={onChange}
      value={value}
    />
  );
}

export default FilterDaysCheckbox;
